import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class itemTreeStore {

    // Properties

    @observable gData = [];
    @observable dataList = [];

    @observable itemTreeLoading = false;

    // Initialization

    @action
    initItemTree() {
        this.itemTreeLoading = true;

        return ApiCaller.Item.apiGetStayMenuTree().then((itemTreeResponses) => {
            if (itemTreeResponses) {
                this.gData = itemTreeResponses;
                this.generateList(this.gData);

                this.itemTreeLoading = false;
            } else {
                this.itemTreeLoading = false;
            }
        }) 
    }

    // GET Properties
    
    @action getItemParentKey(key, tree) {
        let parentKey
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i]
            if (node.children) {
                if (node.children.some(item => item.key === key)) {
                    parentKey = node.key
                } else if (this.getItemParentKey(key, node.children)) {
                    parentKey = this.getItemParentKey(key, node.children)
                }
            }
        }
        return parentKey
    }

    // SET Properties

    @action generateList(data) {
        for (let i = 0; i < data.length; i++) {
            const node = data[i];
            const { key } = node;

            this.dataList.push({ key, title: key });

            if (node.children) {
                this.generateList(node.children);
            }
        }
    }

    @action setitemTreeLoading(value) {
        this.itemTreeLoading = value;
    }
}

export default new itemTreeStore()